<template>
    <div :class="classField">
        <label v-if="label" class="label">
            {{ label }}{{ hideLabelColon ? '' : ':' }}
            <span
                v-if="!hideRequired && required"
                class="label-type"
                :class="{
                    'is-required': required,
                }"
            >
                <span v-if="required">(required)</span>
            </span>
            <span>&nbsp;</span>
            <span v-if="tooltip" :id="`info-${uid}-tooltip`" v-tooltip="tooltipObject">
                <fa-icon icon="info-circle" class="configurationProfile__tooltip-icon" />
            </span>
        </label>
        <p class="control" :class="controlClass">
            <selectize-dropdown
                ref="dropdown"
                :disabled="disabled"
                :placeholder="placeholder"
                :value="modelValue"
                :settings="fullSettings"
                :class="dropdownClass"
                @input="updateValue"
            >
                <slot />
            </selectize-dropdown>
        </p>
        <p v-if="error" class="help has-text-danger" v-text="error" />
        <p v-if="warning" class="help has-text-warning" v-text="warning" />
    </div>
</template>

<script>
import SelectizeDropdown from '../Selectize/Dropdown.vue';

export default {
    components: {
        SelectizeDropdown,
    },

    props: {
        modelValue: { default: '' },
        label: { type: String, default: '' },
        placeholder: { type: String, default: '' },
        error: { type: String, default: '' },
        warning: { type: String, default: '' },
        settings: { type: Object, default: () => ({ maxItems: 1 }) },
        required: { type: Boolean, default: false },
        hideRequired: { type: Boolean, default: false },
        dropdownClass: { type: String, default: '' },
        focus: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        tooltip: { type: [String, Object], default: '' },
        hideLabelColon: { type: Boolean, default: false },
        nameOrLabel: { type: Boolean, default: true },
        hasNewField: { type: Boolean, default: false },
        fieldValidPosition: { type: Boolean, default: false },
    },

    emits: ['update:modelValue', 'input', 'focus'],

    computed: {
        classField() {
            return {
                field: true,
                'field--validPosition': this.fieldValidPosition,
            };
        },

        tooltipObject() {
            if (typeof this.tooltip === 'object') {
                return {
                    placement: 'top',
                    autoHide: false,
                    container: `#info-${this.uid}-tooltip`,
                    ...this.tooltip,
                };
            }

            return {
                placement: 'top',
                autoHide: false,
                container: `#info-${this.uid}-tooltip`,
                content: this.tooltip,
            };
        },

        uid() {
            return this.$.uid;
        },

        dropdown() {
            return this.$refs.dropdown.$el.selectize;
        },

        fullSettings() {
            return Object.assign(
                {},
                {
                    placeholder: this.placeholder,
                },
                this.settings
            );
        },

        controlClass() {
            let classes = [];

            if (this.error) {
                classes.push('is-danger');
            }

            return classes.join(' ');
        },
    },

    methods: {
        updateValue(value) {
            this.$emit('update:modelValue', value);
            this.$emit('input', value);
        },

        handleAddNewField() {
            const valueField = this.settings.valueField || 'value';
            this.dropdown.addOption({
                [valueField]: 'new_field',
                text: 'New Field',
                name: 'New Field',
                $order: 1000,
                render: (data) => {
                    return `
                        <div class="option-newField">
                            <button class="button is-primary">
                                ${this.nameOrLabel ? data.text : data.name}
                            </button>
                        </div>
                    `;
                },
            });
        },
    },

    mounted() {
        if (this.focus) {
            this.dropdown.focus();
        }
        if (this.hasNewField) {
            this.handleAddNewField();
        }
        this.dropdown.on('focus', () => this.$emit('focus', true));
        this.dropdown.on('blur', () => this.$emit('focus', false));
    },
};
</script>

<style>
.caret-free .selectize-input:after {
    content: none !important;
}
</style>
